export const CARD_PLACEHOLDER = Symbol('CARD_PLACEHOLDER')
